/* eslint id-length:[2, {"exceptions":["a", "b"]}] */
import { appDefault } from '../config/config';

/**
 * Does custom sorting for the checkbox lists with territories
 */
export default function() {
  return function(column = {}) {
    return Object.keys(column).sort(territorySort);
  };
}

export function territorySort(a, b) {
  const aIsTerritory = appDefault.kffTerritories.indexOf(a) > -1 ||
    appDefault.normalizedKffTerritories.indexOf(a) > -1;
  const bIsTerritory = appDefault.kffTerritories.indexOf(b) > -1 ||
    appDefault.normalizedKffTerritories.indexOf(b) > -1;

  // Check if MA Region
  if (a.indexOf('ma-region') >= 0 && b.indexOf('ma-region') >= 0) {
    return parseInt(a.split('-')[2], 10) - parseInt(b.split('-')[2], 10);
  }

  if (aIsTerritory && bIsTerritory) {
    return a.localeCompare(b);
  } else if (aIsTerritory || bIsTerritory) {
    return aIsTerritory ? 1 : -1;
  }

  return a.localeCompare(b);
}



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/filters/territorySortFilter.js